var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@naturehouse/design-system/components/atoms/button/Button.html.njk"] = require( "@naturehouse/design-system/components/atoms/button/Button.html.njk" );




var shim = require("/builds/natuurhuisje/nature.house/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["design-system/v3/components/molecules/toggle-icon-button/ToggleIconButton.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = "";
frame.set("label", t_1, true);
if(frame.topLevel) {
context.setVariable("label", t_1);
}
if(frame.topLevel) {
context.addExport("label", t_1);
}
output += "\n";
var t_2;
t_2 = "dark";
frame.set("variant", t_2, true);
if(frame.topLevel) {
context.setVariable("variant", t_2);
}
if(frame.topLevel) {
context.addExport("variant", t_2);
}
output += "\n\n<div\n    is=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "toggleIconButtonClass"),"toggle-icon-button"), env.opts.autoescape);
output += "\"\n    class=\"nh-toggle-icon-button\"\n    default-icon=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "defaultIcon")),"name"), env.opts.autoescape);
output += "\"\n    active-icon=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeIcon")),"name"), env.opts.autoescape);
output += "\"\n    ";
if(runtime.contextOrFrameLookup(context, frame, "active")) {
output += "active";
;
}
frame = frame.push();
var t_5 = env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "data"));
if(t_5) {t_5 = runtime.fromIterator(t_5);
var t_3;
if(runtime.isArray(t_5)) {
var t_4 = t_5.length;
for(t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3][0];
frame.set("[object Object]", t_5[t_3][0]);
var t_7 = t_5[t_3][1];
frame.set("[object Object]", t_5[t_3][1]);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
output += " ";
output += runtime.suppressValue(t_6, env.opts.autoescape);
if(t_7) {
output += "=\"";
output += runtime.suppressValue(t_7, env.opts.autoescape);
output += "\"";
;
}
;
}
} else {
t_3 = -1;
var t_4 = runtime.keys(t_5).length;
for(var t_8 in t_5) {
t_3++;
var t_9 = t_5[t_8];
frame.set("name", t_8);
frame.set("value", t_9);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
output += " ";
output += runtime.suppressValue(t_8, env.opts.autoescape);
if(t_9) {
output += "=\"";
output += runtime.suppressValue(t_9, env.opts.autoescape);
output += "\"";
;
}
;
}
}
}
frame = frame.pop();
output += "\n>\n    ";
if(runtime.contextOrFrameLookup(context, frame, "active")) {
output += "\n        ";
var t_10;
t_10 = runtime.contextOrFrameLookup(context, frame, "activeIcon");
frame.set("icon", t_10, true);
if(frame.topLevel) {
context.setVariable("icon", t_10);
}
if(frame.topLevel) {
context.addExport("icon", t_10);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "defaultIcon");
frame.set("icon", t_11, true);
if(frame.topLevel) {
context.setVariable("icon", t_11);
}
if(frame.topLevel) {
context.addExport("icon", t_11);
}
output += "\n    ";
;
}
output += "\n\n    ";
var t_12;
t_12 = {};
frame.set("data", t_12, true);
if(frame.topLevel) {
context.setVariable("data", t_12);
}
if(frame.topLevel) {
context.addExport("data", t_12);
}
output += "\n    ";
if(env.getTest("defined").call(context, runtime.contextOrFrameLookup(context, frame, "button")) === true && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "button")),"data")) {
output += "\n        ";
var t_13;
t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "button")),"data");
frame.set("data", t_13, true);
if(frame.topLevel) {
context.setVariable("data", t_13);
}
if(frame.topLevel) {
context.addExport("data", t_13);
}
output += "\n    ";
;
}
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("@naturehouse/design-system/components/atoms/button/Button.html.njk", false, "design-system/v3/components/molecules/toggle-icon-button/ToggleIconButton.html.njk", false, function(t_15,t_14) {
if(t_15) { cb(t_15); return; }
callback(null,t_14);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_17,t_16) {
if(t_17) { cb(t_17); return; }
callback(null,t_16);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["design-system/v3/components/molecules/toggle-icon-button/ToggleIconButton.html.njk"] , dependencies)